<template>
  <div>
    <div class="searchBox">
			<div class="searchLeft">
				<el-input size="medium" v-model="searchForm.userId" placeholder="请输入用户ID"  @keyup.enter.native="getTableList"></el-input>
				<el-date-picker
				size="medium"
					v-model="searchForm.startTime"
					type="date"
					value-format="yyyy-MM-dd"
					:picker-options="pickerOptionsStart"
					placeholder="请选择开始时间">
				</el-date-picker>
				<el-date-picker
					size="medium"
					v-model="searchForm.endTime"
					type="date"
					value-format="yyyy-MM-dd"
					:picker-options="pickerOptionsEnd"
					placeholder="请选择结束时间">
				</el-date-picker>
				<el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
				<el-button size="medium" type="primary" icon="el-icon-plus" @click="openMoudel">添加</el-button>
				<!-- <a :href="url+'/companyPowerDaily/export?startTime='+searchForm.startTime + '&&endTime='+searchForm.endTime" style="margin-left:20px">
					<el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
				</a> -->
			</div>
		</div>
		<el-table
			border
			:data="tableData"
			height="73vh"
			style="width: 100%">
			<el-table-column
				type="index"
        width="60px"
				label="序号">
			</el-table-column>
			<el-table-column
				prop="userId"
				label="用户ID">
			</el-table-column>
			<el-table-column
				prop="phone"
				label="手机号">
			</el-table-column>
			<el-table-column
				prop="email"
				label="邮箱地址">
			</el-table-column>
			<el-table-column
				prop="name"
				label="OP备注名">
			</el-table-column>
			<el-table-column
				prop="createTime"
				width="160px"
				label="添加时间">
			</el-table-column>
			<el-table-column
				width="100"
				label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="danger" @click="deleteType(scope.row)"><i class="el-icon-delete"></i>删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
		<el-dialog
      title="新增"
      class="xxx_box"
      :visible.sync="dialogVisible"
      width="440px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="OP名" prop="userId">
            <el-input placeholder="请输入用户ID" v-model="ruleForm.userId" style="width:240px" oninput="value=value.replace(/[^\d]/g,'')" maxLength='6'></el-input>
          </el-form-item>
          <el-form-item label="备注名" prop="name">
            <el-input placeholder="请输入OP的备注名" v-model="ruleForm.name" style="width:240px" maxlength="10"></el-input>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var checkNum2 = (rule, value, callback) => {
      var reg = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]"); 
      if (!value) {
        return callback(new Error('请输入备注名'));
      }else {
        if (reg.test(value)) {
          callback(new Error('请输入正确的备注名'));
        } else {
          callback();
        }
      }
    };
    var checkNum1 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入用户ID'));
      }else {
        console.log(value.toString().lenght)
        if (value.toString().lenght>6) {
          callback(new Error('请输入正确的用户ID'));
        } else {
          callback();
        }
      }
    };
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        startTime:'',
        endTime:'',
      },
      tableData: [],
      url: window.g.host,
			dialogVisible: false,
			ruleForm: {},
      rules: {
        name: [
          { required: true, validator: checkNum2, trigger: 'blur' }
        ],
         userId: [
          { required: true, validator: checkNum1, trigger: 'blur' }
        ],
      },
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    openMoudel(){
      this.dialogVisible=true
      this.ruleForm={
        userId:'',
        name: null
      }
      this.resetForm('ruleForm')
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    deleteType(row){
        this.$confirm(`确定要删除当前数据吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res = await this.$http.deleteOperator({id:row.id});
          if (res) {
            this.$message.success('操作成功！');
            this.getTableList()
          }
        }).catch(() => {
                
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await this.$http.addOperator({...this.ruleForm});
          if (res) {
            this.$message.success('操作成功！');
            this.dialogVisible=false;
            this.getTableList()
          }
        } else {
        console.log('error submit!!');
        return false;
        }
      });
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.operatorPageList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
<style>
.xxx_box .el-input__inner{
  line-height: normal;
}
</style>
